import { Component, OnInit, inject, signal } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { Mdm } from '../../models/mdm';
import { MdmService } from '../../services/mdm.service';
import { TranslatePipe } from '@ngx-translate/core';
import {
  DateTimePipe,
  NimmstaTimeAgoPipe,
} from '@nimmsta/ng-commons-lib/pipes';
import { ErrorComponent } from '@nimmsta/ng-commons-lib/error';
import { HeaderBarComponent } from '@nimmsta/ng-commons-lib/header-bar';
import { LoadingIndicatorComponent } from '@nimmsta/ng-commons-lib/loading-indicator';

type MdmDetailSection = 'activity' | 'software' | 'hardware' | 'metadata';

@Component({
  templateUrl: 'mdm-detail.component.html',
  imports: [
    TranslatePipe,
    HeaderBarComponent,
    LoadingIndicatorComponent,
    ErrorComponent,
    NimmstaTimeAgoPipe,
    DateTimePipe,
  ],
})
export class MdmDetailComponent implements OnInit {
  private mdmService = inject(MdmService);
  private route = inject(ActivatedRoute);

  error?: HttpErrorResponse;

  device?: Mdm;

  parsedAdditionalData: [string, string][] = [];

  isLoading = false;

  readonly openSections = signal<Record<MdmDetailSection, boolean>>({
    activity: true,
    software: false,
    hardware: false,
    metadata: false,
  });

  ngOnInit(): void {
    this.isLoading = true;
    this.route.params.subscribe((params) => {
      this.mdmService.get(params['id']).subscribe({
        next: (device: Mdm) => {
          this.device = device;
          this.parsedAdditionalData = this.mdmService.parseVisibleAdditionalData(device.additionalData);
          this.isLoading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.error = error;
          this.isLoading = false;
        },
      });
    });
  }

  toggleSection(section: MdmDetailSection): void {
    this.openSections.update((sections) => ({
      ...sections,
      [section]: !sections[section],
    }));
  }

  isSectionOpen(section: MdmDetailSection): boolean {
    return this.openSections()[section];
  }
}
